export type CefrLevel = 'B1' | 'B2' | 'C1';
export type WordTopic = 'education' | 'environment' | 'technology' | 'health' | 'work' | 'society';
export type WordRow = [word: string, partOfSpeech: string, level: CefrLevel, topic: WordTopic, uz: string, ru: string, example: string];

export interface ListWord {
  word: string;
  partOfSpeech: string;
  level: CefrLevel;
  topic: WordTopic;
  uz: string;
  ru: string;
  example: string;
}

export const CEFR_LEVELS: CefrLevel[] = ['B1', 'B2', 'C1'];
export const WORD_TOPICS: WordTopic[] = ['education', 'environment', 'technology', 'health', 'work', 'society'];

export const toListWord = ([word, partOfSpeech, level, topic, uz, ru, example]: WordRow): ListWord => ({
  word, partOfSpeech, level, topic, uz, ru, example,
});
